// extracted by mini-css-extract-plugin
module.exports = {"messageWrapper":"RebootSystem_messageWrapper__ZGdTF","closeMessage":"RebootSystem_closeMessage__2bKep"};